import React from "react";
import { Row, Col } from "reactstrap";

const RotorSystem_Conventional = () => {
  return (
    <>
      <Row>
        <Col xs={12} lg={8} md={12} className="text-center d-flex align-items-center mb-4 mb-md-0 order-lg-2 order-2">
          <div className="embed-responsive embed-responsive-16by9" style={{marginBottom: '20px'}}>
            <iframe
              title="The Rotors-Problem Statement"
              src="https://player.vimeo.com/video/896276132?h=0890c7dde2"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              className="embed-responsive-item"
            ></iframe>
          </div>
        </Col>
        <Col xs={12} lg={4} md={12} className="text-center d-flex align-items-center text-lg-left mb-4 mb-md-0 order-lg-1 order-sm-1 order-xs-1 order-1">
          <p style={{ color: "white", fontSize: '1.25em', marginBottom: '20px' }}>
            <span style={{ fontSize: '1.75em', color: "white" }}>Conventional Rotor Systems<br/><br/></span>
            Shaft-based rotors, commonly found in conventional helicopters and rotorcraft, are limited in their ability to fully utilize their span and swept area, leading to additional noise and efficiency losses.<br/>
          </p>
        </Col>
      </Row>
    </>
  );
};

export default RotorSystem_Conventional;
